
const Research = () => {
  const researchTopics = [
    {
      title: 'Why Invest in Rural South Africa?',
      description: 'Comprehensive analysis of investment opportunities and market potential in rural South African markets.',
      image: 'https://public.readdy.ai/ai/img_res/7d1233e61f80bb787a756349f450ecb4.jpg',
      link: '/research/why-invest-rural-south-africa'
    },
    {
      title: 'African Urbanisation Challenges',
      description: 'Understanding the rapid pace of African urbanisation and the opportunities it creates for rural investment.',
      image: 'https://readdy.ai/api/search-image?query=African%20city%20skyline%20contrasted%20with%20rural%20areas%2C%20urbanization%20trends%20visualization%2C%20population%20movement%20graphics%2C%20modern%20African%20urban%20development%2C%20research%20infographic%20style&width=400&height=300&seq=research-002&orientation=landscape',
      link: '/research/african-urbanisation-challenges'
    },
    {
      title: 'Rural Africa\'s Tremendous Potential',
      description: 'Exploring the untapped economic potential of rural African markets and development opportunities.',
      image: 'https://readdy.ai/api/search-image?query=Thriving%20African%20rural%20community%20with%20modern%20amenities%2C%20successful%20agricultural%20projects%2C%20renewable%20energy%20installations%2C%20economic%20growth%20indicators%2C%20bright%20and%20optimistic%20atmosphere&width=400&height=300&seq=research-003&orientation=landscape',
      link: '/research/rural-africa-potential'
    },
    {
      title: 'Understanding Rural Spaces in Africa',
      description: 'Deep dive into the unique characteristics and challenges of rural African communities and markets.',
      image: 'https://readdy.ai/api/search-image?query=Traditional%20African%20village%20transitioning%20to%20modern%20development%2C%20community%20gathering%20spaces%2C%20local%20markets%2C%20cultural%20preservation%20with%20modern%20infrastructure%2C%20documentary%20photography%20style&width=400&height=300&seq=research-004&orientation=landscape',
      link: '/research/understanding-rural-spaces-africa'
    },
    {
      title: 'Rural Development & Land Ownership',
      description: 'Our strategic approach to land ownership and development in rural South African contexts.',
      image: 'https://readdy.ai/api/search-image?query=Land%20surveying%20and%20development%20planning%20in%20rural%20Africa%2C%20legal%20documents%20and%20land%20maps%2C%20sustainable%20development%20projects%2C%20professional%20land%20management%2C%20technical%20documentation%20style&width=400&height=300&seq=research-005&orientation=landscape',
      link: '/research/rural-development-land-ownership'
    },
    {
      title: 'Rural Grocery Store Development',
      description: 'The importance of developing modern grocery infrastructure to replace traditional spaza shops.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20rural%20grocery%20store%20in%20African%20setting%2C%20well-stocked%20shelves%2C%20local%20customers%20shopping%2C%20clean%20and%20organized%20retail%20environment%2C%20community%20commerce%20development&width=400&height=300&seq=research-006&orientation=landscape',
      link: '/research/rural-grocery-store-development'
    }
  ];

  return (
    <section id="research" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Research-Driven Investment Insights
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our comprehensive research provides the foundation for successful rural investment strategies. Explore our latest findings and market analysis.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {researchTopics.map((topic, index) => (
            <article key={index} className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="relative">
                <img 
                  src={topic.image}
                  alt={topic.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="absolute top-4 right-4 bg-emerald-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                  Research
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{topic.title}</h3>
                <p className="text-gray-600 mb-4 leading-relaxed">{topic.description}</p>
                <a 
                  href={topic.link}
                  className="inline-flex items-center text-emerald-600 hover:text-emerald-700 font-medium cursor-pointer"
                >
                  Read Full Report
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-12">
          <button className="bg-emerald-600 text-white px-8 py-4 rounded-lg hover:bg-emerald-700 transition-colors duration-200 font-semibold whitespace-nowrap cursor-pointer">
            Access Full Research Library
          </button>
        </div>
      </div>
    </section>
  );
};

export default Research;
